import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, FormHelperText,
    CircularProgress
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { MaterialMaster } from '../TitleList';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { fetchMaterialData } from '../../Store/PHPSlice/Material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMatStkValue } from '../../Store/PHPSlice/MatInward';
import { fetchEmployeeData } from '../../Store/PHPSlice/Employee';
import { createMatOutwardEntry } from '../../Store/PHPSlice/MatOutward';
import { selectMaterials, selectEmployees, selectMatInwardData } from '../Selectors/Master/OutwardSelectors';
import { errorStyles } from '../../Utils/table';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';


const MatOutwardEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: '',
        outwardNo: '',
        empId: ' ',
        materialNm: ' ',
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});
    const [tableRows, setTableRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const materials = useSelector(selectMaterials);
    const employees = useSelector(selectEmployees);
    const stk_value = useSelector(selectMatInwardData);

    useEffect(() => {
        dispatch(fetchMaterialData());
        dispatch(fetchEmployeeData());
    }, [dispatch]);
    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    // const handleAddMaterial = () => {
    //     const selectedMaterial = materials.data.find(item => item.ID === formData.materialNm);
    //     const mateId = selectedMaterial.ID;

    //     if (selectedMaterial) {
    //         setTableRows([
    //             ...tableRows,
    //             {
    //                 id: tableRows.length + 1,
    //                 materialId: selectedMaterial.ID,
    //                 materialNm: selectedMaterial.materialNm,
    //                 description: selectedMaterial.description || '',
    //                 size: selectedMaterial.size || '',
    //                 packets: selectedMaterial.packets || '',
    //                 qty: selectedMaterial.qty,
    //             }
    //         ]);

    //         dispatch(fetchMatStkValue(mateId));
    //     }
    //     console.log("qty=>",selectedMaterial.qty);
    //     setFormData({
    //         ...formData,
    //         materialNm: ''
    //     })
    // };
    // ✅ Corrected function to fetch and add material with stock qty
    const handleAddMaterial = () => {
        const selectedMaterial = materials.data.find(item => item.ID === formData.materialNm);
        const mateId = selectedMaterial?.ID;

        if (!selectedMaterial) {
            alert("Please select a material first!");
            return;
        }

        dispatch(fetchMatStkValue(mateId))
            .unwrap()
            .then((res) => {
                const inwardQty = res.data?.[0]?.inwardqty ?? 0;
                const packetQty = res.data?.[0]?.packetqty ?? 0;
                const totalQty = res.data?.[0]?.totqty ?? 0;
                setTableRows((prevRows) => [
                    ...prevRows,
                    {
                        id: prevRows.length + 1,
                        materialId: selectedMaterial.ID,
                        materialNm: selectedMaterial.materialNm,
                        description: selectedMaterial.description || '',
                        size: selectedMaterial.size || '',
                        packets: selectedMaterial.packets || '',
                        packetqty: packetQty,
                        inwardqty: inwardQty, // ✅ this will now show proper inward qty
                        totqty: totalQty,
                        qty: '' // outward qty left empty
                    }
                ]);
            })
            .catch((err) => {
                console.error('Error fetching stock value:', err);
            });

        setFormData({
            ...formData,
            materialNm: ''
        });
    };


    const handleInputChange = (index, field, value) => {
        const val = stk_value.data.length > 0 ? stk_value.data[0].qty : 0; // Default to 0 if singelMatInward.data is not yet populated
        let newValue = value;

        if (field === 'qty' && parseInt(value, 10) > val) {
            alert(`Value cannot be greater than ${val}`);
            newValue = ''; // Reset the field to empty string
        }

        const updatedRows = tableRows.map((row, i) => {
            if (i === index) {
                return { ...row, [field]: newValue.toUpperCase() };
            }
            return row;
        });

        setTableRows(updatedRows);
    };

    const handleCheckboxChange = (rowId) => {
        if (selectedRows.includes(rowId)) {
            setSelectedRows(selectedRows.filter(id => id !== rowId));
        } else {
            setSelectedRows([...selectedRows, rowId]);
        }
    };

    const handleDeleteMaterial = () => {
        setTableRows(tableRows.filter(row => !selectedRows.includes(row.id)));
        setSelectedRows([]);
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.empId) newErrors.empId = 'Employee Name is required';
        // if (!formData.materialNm) newErrors.materialNm = 'Material Name is required';
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }


        if (tableRows.length > 0) {
            var finalObject = {
                dt: formData.dt,
                outwardNo: formData.outwardNo,
                empId: formData.empId,
                matId: tableRows.map(row => row.materialId),
                pkt: tableRows.map(row => row.packets),
                packetqty: tableRows.map(row => row.packetqty),
                qty: tableRows.map(row => row.qty),
                userId: formData.userId
            };

            setLoading(false);
            try {
                const result = await dispatch(createMatOutwardEntry(finalObject)).unwrap();
                // console.log('POST request successful!', result);
                alert("Material Outward Added");
                window.location.reload();
            } catch (error) {
                console.error('Error while making POST request:', error);
            } finally {
                setLoading(false);
            }

        } else {
            alert("Select Employee & Material & Enter table details");
        }



    };


    const dropdownlist = [

        {
            label: 'Employee',
            id: 'empId',
            options: employees?.data || [],
            value: formData.empId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'empId', value: newValue ? newValue.ID : '' } }, 'empId'),
            getOptionLabel: (option) => option.empNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            errors: errors.empId
        },
        {
            label: 'Material',
            id: 'materialNm',
            options: materials?.data || [],
            value: formData.materialNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'materialNm', value: newValue ? newValue.ID : '' } }, 'materialNm'),
            getOptionLabel: (option) => `${option.materialNm}-${option.size}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            errors: errors.materialNm
        },
    ];

    return (
        <>
            <Titlebar data={MaterialMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Material Outward Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='dt' >Date:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='dt'
                                                    name='dt'
                                                    type='date'
                                                    value={formData.dt}
                                                    onChange={handleDateChange}
                                                    inputProps={{ style: styled.inputDate }}
                                                    sx={inputStyles}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='outwardNo'>Outward No:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id="outwardNo"
                                                    name="outwardNo"
                                                    value={formData.outwardNo}
                                                    onChange={(e) => setFormData({ ...formData, outwardNo: e.target.value })}
                                                    inputProps={{ style: styled.inputDate }}
                                                    sx={inputStyles}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <InputLabel id="empId">Employee Name :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="empId"
                                                    id="empId"
                                                    name="empId"
                                                    value={formData.empId}
                                                    onChange={(e) => handleDropdownChange(e, 'empId')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value=" ">Select an option</MenuItem>
                                                    {
                                                        employees ? employees.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.ID}>{item.empNm}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                                {errors.empId && <FormHelperText style={errorStyles}>{errors.empId}</FormHelperText>}

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <InputLabel id="materialNm">Material Name :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="materialNm"
                                                    id="materialNm"
                                                    name="materialNm"
                                                    value={formData.materialNm}
                                                    onChange={(e) => handleDropdownChange(e, 'materialNm')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value=" ">Select an option</MenuItem>

                                                    {
                                                        materials ? materials.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.ID}>{item.materialNm} - {item.size}</MenuItem>

                                                        )) : []
                                                    }
                                                </Select>
                                                {errors.materialNm && <FormHelperText style={errorStyles}>{errors.materialNm}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}


                                {dropdownlist?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        errors={drop.errors}
                                    />
                                ))
                                }


                                <Grid item xs={12} md={6}>
                                    <Button variant="contained" color="primary" onClick={handleAddMaterial} sx={{ mr: 2 }}>Add</Button>
                                    <Button variant="contained" color="primary" onClick={handleDeleteMaterial}>Delete</Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ marginTop: '1%' }}>
                                        <TableContainer width={400}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Select</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Material Name</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Description</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Per Packet Qty</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'> Packet Qty</TableCell>

                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Stock Qty</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Outward Qty</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableRows?.map((row, index) => (
                                                        <TableRow key={row.id}>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <Checkbox
                                                                    checked={selectedRows.includes(row.id)}
                                                                    onChange={() => handleCheckboxChange(row.id)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{row.id}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    value={row.materialNm}
                                                                    onChange={(e) => handleInputChange(index, 'materialNm', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable, readOnly: true }}

                                                                /> */}

                                                                {row.materialNm}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    value={row.description}
                                                                    onChange={(e) => handleInputChange(index, 'description', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable, readOnly: true }}
                                                                /> */}

                                                                {row.description}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    value={row.size}
                                                                    onChange={(e) => handleInputChange(index, 'size', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable, readOnly: true }}
                                                                /> */}

                                                                {row.size}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    value={row.packets}
                                                                    onChange={(e) => handleInputChange(index, 'packets', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable, readOnly: true }}
                                                                /> */}

                                                                {row.packets}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    value={row.packetqty}
                                                                    onChange={(e) => handleInputChange(index, 'packetqty', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable, readOnly: true }}
                                                                /> */}


                                                                {row.packetqty}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    value={row.totqty}
                                                                    onChange={(e) => handleInputChange(index, 'totqty', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable, readOnly: true }}
                                                                /> */}

                                                                {row.totqty}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <TextField
                                                                    value={row.qty}
                                                                    onChange={(e) => handleInputChange(index, 'qty', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable }}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid>
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default MatOutwardEntry;
